import React from 'react';

type TProps = {
  variable?: string;
  ignore?: boolean;
  noTranslate?: boolean;
  isolate?: boolean;
  element?: string;
  children: React.ReactNode;
}

export function T({variable, ignore = false, noTranslate = false, isolate = false, element = 'span', children, ...props}: TProps) {
  if (variable) {
    return <var {...{'data-var': variable}}>{children}</var>;
  }

  if (ignore) {
    return React.createElement(element, {'data-ignore': 'true', ...props}, children);
  }

  if (noTranslate) {
    return React.createElement(element, {'data-notranslate': 'true', ...props}, children);
  }

  if (isolate) {
    return React.createElement(element, {'data-isolate': 'true', ...props}, children);
  }

  return React.createElement(element, props, children);
}